var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOtherLink(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7294_89890)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.76953 14C8.8741 14 9.76953 13.1046 9.76953 12C9.76953 10.8954 8.8741 10 7.76953 10C6.66496 10 5.76953 10.8954 5.76953 12C5.76953 13.1046 6.66496 14 7.76953 14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7695 12C14.7695 13.1046 13.8741 14 12.7695 14C11.6649 14 10.7695 13.1046 10.7695 12C10.7695 10.8954 11.6649 10 12.7695 10C13.8741 10 14.7695 10.8954 14.7695 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7695 14C18.8741 14 19.7695 13.1046 19.7695 12C19.7695 10.8954 18.8741 10 17.7695 10C16.6649 10 15.7695 10.8954 15.7695 12C15.7695 13.1046 16.6649 14 17.7695 14Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7695 12C24.7695 18.6274 19.3969 24 12.7695 24C6.14211 24 0.769531 18.6274 0.769531 12C0.769531 5.37258 6.14211 0 12.7695 0C19.3969 0 24.7695 5.37258 24.7695 12ZM22.7695 12C22.7695 17.5228 18.2923 22 12.7695 22C7.24668 22 2.76953 17.5228 2.76953 12C2.76953 6.47715 7.24668 2 12.7695 2C18.2923 2 22.7695 6.47715 22.7695 12Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7294_89890"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.769531)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherLink);
export default __webpack_public_path__ + "static/media/other-link.8751681c155edd166ad95c404e4b724f.svg";
export { ForwardRef as ReactComponent };